import moment from "moment";
import { isArrayEmpty, isObjectNull } from "components/helpers/ObjectHelpers";
import { ApplicationRightProps } from 'components/props/ApplicationRightProps';

export interface IApplicationRightService {
    canAccess(systemName: string[]): boolean;
}

export class ApplicationRightService implements IApplicationRightService {
    _applicationRights: ApplicationRightProps[] = [];

    constructor(
        applicationRights: ApplicationRightProps[]
    ) {
        this._applicationRights = applicationRights;
    }

    canAccess(systemNames: string[]): boolean {
        if (isArrayEmpty(systemNames)) return true;
        if (isArrayEmpty(this._applicationRights)) return false;

        const now = moment();
        const result: ApplicationRightProps[] = [];

        for (const systemName of systemNames) {
            const applicationRight = this._applicationRights.find(r => r.systemName === systemName);
            if (isObjectNull(applicationRight)) continue;

            const expireDate = moment(applicationRight!.expireDate);
            if (!now.isBefore(expireDate)) continue;

            result.push(applicationRight!);
        }
        return result.length > 0;
    }
}
